// extracted by mini-css-extract-plugin
export var divider = "_14-0";
export var dividerText = "_14-1";